import React from 'react';
import { SxStyle } from '../../types';
import Paper from '@mui/material/Paper';

const styles: SxStyle = {
  container: {
    position: 'relative',
    borderRadius: 6,
    padding: 2,
    height: '100%',
  },
};

interface Props {
  children: React.ReactNode;
}

const PreviewBox = ({ children }: Props) => {
  return (
    <Paper sx={styles.container} elevation={3}>
      {children}
    </Paper>
  );
};

export default PreviewBox;
